import React, { createContext, useContext, useState } from 'react';

const SelectContext = createContext({
    value: undefined,
    onValueChange: () => { },
    open: false,
    setOpen: () => { }
});

const triggerStyle = {
    display: 'flex',
    height: '2.5rem',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '0.375rem',
    border: '1px solid #e2e8f0',
    backgroundColor: '#ffffff',
    padding: '0.5rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#0f172a',
    cursor: 'pointer'
};

const contentStyle = {
    position: 'absolute',
    top: '100%',
    left: 0,
    zIndex: 50,
    minWidth: '8rem',
    width: '100%',
    overflow: 'hidden',
    borderRadius: '0.375rem',
    border: '1px solid #e2e8f0',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginTop: '0.25rem'
};

const itemStyle = {
    position: 'relative',
    display: 'flex',
    width: '100%',
    cursor: 'default',
    userSelect: 'none',
    alignItems: 'center',
    borderRadius: '0.125rem',
    padding: '0.375rem 0.5rem 0.375rem 2rem',
    fontSize: '0.875rem',
    outline: 'none',
    backgroundColor: 'transparent',
    color: '#0f172a'
};

export const Select = ({ children, value, onValueChange }) => {
    const [open, setOpen] = useState(false);
    return (
        <SelectContext.Provider value={{ value, onValueChange, open, setOpen }}>
            <div style={{ position: 'relative' }}>
                {children}
            </div>
        </SelectContext.Provider>
    );
};

export const SelectTrigger = ({ className, children, style, ...props }) => {
    const { setOpen, open } = useContext(SelectContext);
    return (
        <button
            type="button"
            onClick={() => setOpen(!open)}
            style={{ ...triggerStyle, ...style }}
            {...props}
        >
            {children}
            <span style={{ opacity: 0.5 }}>▼</span>
        </button>
    );
};

export const SelectValue = ({ placeholder }) => {
    const { value } = useContext(SelectContext);
    return <span style={{ pointerEvents: 'none' }}>{value || placeholder}</span>;
};

export const SelectContent = ({ className, children, style, ...props }) => {
    const { open } = useContext(SelectContext);
    if (!open) return null;

    return (
        <div
            style={{ ...contentStyle, ...style }}
            {...props}
        >
            <div style={{ padding: '0.25rem' }}>{children}</div>
        </div>
    );
};

export const SelectItem = ({ className, children, value, style, ...props }) => {
    const { onValueChange, setOpen, value: selectedValue } = useContext(SelectContext);

    const handleSelect = () => {
        onValueChange(value);
        setOpen(false);
    };

    const isSelected = selectedValue === value;

    return (
        <div
            role="option"
            onClick={handleSelect}
            style={{
                ...itemStyle,
                backgroundColor: isSelected ? '#f1f5f9' : 'transparent',
                cursor: 'pointer',
                ...style
            }}
            {...props}
        >
            {isSelected && (
                <span style={{ position: 'absolute', left: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    ✓
                </span>
            )}
            <span style={{ flexGrow: 1 }}>{children}</span>
        </div>
    );
};
